"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeartFailueMedicalTherapy = createHeartFailueMedicalTherapy;
const events_1 = require("../../../events");
const heartFailureMedicalTherapy_1 = require("../../../forms/htx/current-cardiological-state/heartFailureMedicalTherapy");
const queries_1 = require("../queries");
const messages = {
    heartFailureMedicalTherapy: {
        id: "dashboard.heart_failure_medical_therapy",
        defaultMessage: "Gyógyszeres kezelés"
    },
    activeIngredient: {
        id: "dashboard.active_ingredient",
        defaultMessage: "Gyógyszer"
    },
    dose: {
        id: "dashboard.dose",
        defaultMessage: "Napi összdózis"
    },
    intakeType: {
        id: "dashboard.intake_type",
        defaultMessage: "PO/IV"
    },
    acei: {
        id: "dashboard.acei",
        defaultMessage: "ACEi"
    },
    bbl: {
        id: "dashboard.bbl",
        defaultMessage: "BBL"
    },
    arb: {
        id: "dashboard.arb",
        defaultMessage: "ARB"
    },
    mra: {
        id: "dashboard.mra",
        defaultMessage: "MRA"
    },
    arni: {
        id: "dashboard.arni",
        defaultMessage: "ARNI"
    },
    ivabradine: {
        id: "dashboard.ivabradine",
        defaultMessage: "Ivabradine"
    },
    diuretic: {
        id: "dashboard.diuretic",
        defaultMessage: "Diureticum"
    },
    antiarrhythmicAgent: {
        id: "dashboard.antiarrhythmic_agent",
        defaultMessage: "Antiarritmiás szer"
    },
    anticoagulant: {
        id: "dashboard.anticoagulant",
        defaultMessage: "Anticoaguláns szer"
    },
    trombocytaAggregationInhibitor: {
        id: "dashboard.trombocyta_aggregation_inhibitor",
        defaultMessage: "Trombocyta aggregáció gátló szer"
    },
    statin: {
        id: "dashboard.statin",
        defaultMessage: "Sztatin"
    },
    digitalis: {
        id: "dashboard.digitalis",
        defaultMessage: "Digitálisz"
    },
    antibiotic: {
        id: "dashboard.antibiotic",
        defaultMessage: "Antibiotikum"
    },
    allopurinol: {
        id: "dashboard.allopurinol",
        defaultMessage: "Allopurinol"
    },
    dopamine: {
        id: "dashboard.dopamine",
        defaultMessage: "Dopamin"
    },
    dobutamine: {
        id: "dashboard.dobutamine",
        defaultMessage: "Dobutamin"
    },
    norepinephrine: {
        id: "dashboard.norepinephrine",
        defaultMessage: "(Nor)adrenalin"
    },
    pdeInhibitor: {
        id: "dashboard.pde_inhibitor",
        defaultMessage: "PDE inhibitor"
    },
    levosimendan: {
        id: "dashboard.levosimendan",
        defaultMessage: "Levosimendan"
    },
    other: {
        id: "dashboard.other",
        defaultMessage: "Egyéb"
    },
    microKgMin: {
        id: "dashboard.micro_kg_min",
        defaultMessage: "{dose} microg/kg/min"
    },
    mgWeek: {
        id: "dashboard.mg_week",
        defaultMessage: "{dose} mg/week"
    }
};
const values = [
    {
        key: "acei",
        label: messages.acei,
        activeIngredientMessages: heartFailureMedicalTherapy_1.aceiActiveIngredientMessages
    },
    {
        key: "bbl",
        label: messages.bbl,
        activeIngredientMessages: heartFailureMedicalTherapy_1.bblActiveIngredientMessages
    },
    {
        key: "arb",
        label: messages.arb,
        activeIngredientMessages: heartFailureMedicalTherapy_1.arbActiveIngredientMessages
    },
    {
        key: "mra",
        label: messages.mra,
        activeIngredientMessages: heartFailureMedicalTherapy_1.mraActiveIngredientMessages
    },
    {
        key: "arni",
        label: messages.arni,
        activeIngredientMessages: heartFailureMedicalTherapy_1.arniActiveIngredientMessages
    },
    {
        key: "ivabradine",
        label: messages.ivabradine,
        activeIngredientMessages: heartFailureMedicalTherapy_1.ivabradineActiveIngredientMessages
    },
    {
        key: "diuretic",
        label: messages.diuretic
    },
    {
        key: "antiarrhythmicAgent",
        label: messages.antiarrhythmicAgent
    },
    {
        key: "anticoagulant",
        label: messages.anticoagulant
    },
    {
        key: "trombocytaAggregationInhibitor",
        label: messages.trombocytaAggregationInhibitor
    },
    {
        key: "statin",
        label: messages.statin
    },
    {
        key: "allopurinol",
        label: messages.allopurinol,
        activeIngredientMessages: heartFailureMedicalTherapy_1.allopurinolActiveIngredientMessages
    },
    {
        key: "digitalis",
        label: messages.digitalis
    },
    {
        key: "dopamine",
        label: messages.dopamine,
        activeIngredientMessages: heartFailureMedicalTherapy_1.dopamineActiveIngredientMessages
    },
    {
        key: "dobutamine",
        label: messages.dobutamine,
        activeIngredientMessages: heartFailureMedicalTherapy_1.dobutamineActiveIngredientMessages
    },
    {
        key: "norepinephrine",
        label: messages.norepinephrine,
        activeIngredientMessages: heartFailureMedicalTherapy_1.norepinephrineActiveIngredientMessages
    },
    {
        key: "pdeInhibitor",
        label: messages.pdeInhibitor,
        activeIngredientMessages: heartFailureMedicalTherapy_1.pdeInhibitorActiveIngredientMessages
    },
    {
        key: "levosimendan",
        label: messages.levosimendan,
        activeIngredientMessages: heartFailureMedicalTherapy_1.levosimendanActiveIngredientMessages
    },
    {
        key: "antibiotic",
        label: messages.antibiotic
    },
    {
        key: "other",
        label: messages.other
    }
];
function createHeartFailueMedicalTherapy({ formatMessage, formatMessageMap }, { events }) {
    const createGroup = ({ label, values, activeIngredientMessages }) => ({
        type: "table-group",
        label: formatMessage(label),
        rows: activeIngredientMessages === undefined
            ? values.map(({ activeIngredient, intakeType, dose }) => [
                activeIngredient,
                formatMessageMap(heartFailureMedicalTherapy_1.aceiIntakeTypeMessages, intakeType),
                dose
            ])
            : values.map(({ activeIngredient, otherIngredientName, intakeType, dose }) => {
                const ai = activeIngredient === "other"
                    ? otherIngredientName
                    : formatMessageMap(activeIngredientMessages, activeIngredient);
                return [
                    ai,
                    formatMessageMap(heartFailureMedicalTherapy_1.aceiIntakeTypeMessages, intakeType),
                    dose
                ];
            })
    });
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.heartFailureMedicalTherapy);
    if (event === undefined) {
        return undefined;
    }
    const columns = [
        formatMessage(messages.activeIngredient),
        formatMessage(messages.intakeType),
        formatMessage(messages.dose)
    ];
    const groups = [];
    for (const { key, label, activeIngredientMessages } of values) {
        const values = event.value[key];
        if (values === undefined || values.length === 0) {
            continue;
        }
        groups.push(createGroup({ label, values, activeIngredientMessages }));
    }
    if (groups.length === 0) {
        return undefined;
    }
    const { timestamp, sid, origin } = event;
    return {
        type: "table-group-list",
        label: formatMessage(messages.heartFailureMedicalTherapy),
        attachments: (0, events_1.mapEventsToAttachments)(event),
        columns,
        groups,
        timestamp,
        sid,
        origin
    };
}
